import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { DatePicker } from 'formik-antd';
import moment from 'moment-timezone';
import { Moment } from 'moment';

const PetVaccineDatePicker = ({ name }: {name: string}) => {
  const { values, setFieldValue } = useFormikContext<{noVaccine: boolean}>();

  useEffect(() => {
    if (values.noVaccine) {
      setFieldValue(name, '');
    }
  }, [values.noVaccine, name, setFieldValue]);

  return (
    <DatePicker
      name={name}
      className="element__input"
      format="YYYY/MM/DD"
      showToday={false}
      disabledDate={(current: Moment) => {
        return current < moment('2010/01/01') || current > moment().add(-1, 'days');
      }}
      // disabled={values.noVaccine}
      disabled
      validate={(val) => {
        if (!val && !values.noVaccine) return '請勾選未施打或選擇日期';
        return '';
      }}
      data-fieldname="vaccineDate"
    />
  );
};

export default PetVaccineDatePicker;
